var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "auth-card" },
    [
      _c(
        "q-card-main",
        [
          _vm.requestSuccessful
            ? _c(
                "div",
                { staticClass: "success" },
                [
                  _c("check-mark"),
                  _c("h4", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("forgot_success_title")))
                  ]),
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("forgot_success_body")))
                  ])
                ],
                1
              )
            : [
                _c("h1", { staticClass: "text-center auth-card__heading" }, [
                  _vm._v(_vm._s(_vm.$t("forgot_heading")))
                ]),
                _c("p", { staticClass: "text-center auth-card__description" }, [
                  _vm._v(_vm._s(_vm.$t("forgot_description")))
                ]),
                _c(
                  "form",
                  {
                    attrs: { id: "forgot-form" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.handleForgot($event)
                      }
                    }
                  },
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          error: _vm.errors.has("email"),
                          "error-label": _vm.errors.first("email")
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required|email|max:255",
                              expression: "'required|email|max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            name: "email",
                            type: "email",
                            "float-label": _vm.$t("email"),
                            required: "",
                            autofocus: ""
                          },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email = $$v
                            },
                            expression: "email"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "auth-card__footer row justify-between" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-auto col-xs-12 self-center auth-card__secondary-action"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "router-link",
                                attrs: { to: { name: "login" } }
                              },
                              [_vm._v(_vm._s(_vm.$t("goto_login")))]
                            )
                          ],
                          1
                        ),
                        !_vm.requestSuccessful
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-auto col-xs-12 self-center auth-card__primary-action"
                              },
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { type: "submit", color: "primary" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("forgot")))]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }